<app-range-or-relative-date-input *ngIf="value"
                                  [ngModel]="dateInputModel"
                                  (ngModelChange)="datesChanged($event)">

</app-range-or-relative-date-input>
